import { mdiDesktopClassic } from '@mdi/js'

export default {
  title: 'CBT',
  to: 'cbt-headmaster',
  icon: mdiDesktopClassic,
  resource: 'CbtSchool',
  action: 'read',
}
